"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountUserCommandType = exports.AccountUserCommandStatusReason = exports.AccountUserCommandStatus = void 0;
var AccountUserCommandStatus;
(function (AccountUserCommandStatus) {
    AccountUserCommandStatus["PENDING"] = "PENDING";
    AccountUserCommandStatus["COMPLETED"] = "COMPLETED";
})(AccountUserCommandStatus = exports.AccountUserCommandStatus || (exports.AccountUserCommandStatus = {}));
var AccountUserCommandStatusReason;
(function (AccountUserCommandStatusReason) {
    AccountUserCommandStatusReason["FAILED"] = "FAILED";
    AccountUserCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(AccountUserCommandStatusReason = exports.AccountUserCommandStatusReason || (exports.AccountUserCommandStatusReason = {}));
var AccountUserCommandType;
(function (AccountUserCommandType) {
    AccountUserCommandType["ADD_ROLE"] = "ADD_ROLE";
    AccountUserCommandType["CREATE"] = "CREATE";
    AccountUserCommandType["REMOVE"] = "REMOVE";
    AccountUserCommandType["UPDATE_ALL_ROLES"] = "UPDATE_ALL_ROLES";
})(AccountUserCommandType = exports.AccountUserCommandType || (exports.AccountUserCommandType = {}));
//# sourceMappingURL=account-user-command.js.map